<template>
    <div id="search">
        <Navi currentPage="3" v-if="update"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Search</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="pcga-search-page">
                <div class="pcga-search-box">
                    <el-row>
                        <el-col :span="20">
                            <el-autocomplete
                                :placeholder="tips"
                                prefix-icon="el-icon-search"
                                v-model="search_item"
                                :fetch-suggestions="querySearch"
                                :trigger-on-focus="false"
                                @select="handleSelect"
                                class="search_box"
                            ></el-autocomplete>
                        </el-col>
                        <el-col :span="4">
                            <el-button icon="el-icon-search" type="primary" @click="search">Search</el-button>
                        </el-col>
                    </el-row>
                </div>
                <div class="pcga-search-example">
                    <el-radio-group v-model="radio">
                        <el-radio v-for="(item,i) in search_type" :key="i" :label="i" >{{ item }}</el-radio>
                    </el-radio-group>
                    <div class="example-list">
                        Examples:
                        <div
                            v-for="(item,j) in search_exmple"
                            :key="j"
                            style="display:inline-block"
                            
                        >
                            <el-button
                                type="success"
                                size="mini"
                                round
                                @click="goExample(item.label, j)"
                                style="font-size: 12px;"
                            >{{ item.label }}</el-button>
                            <el-divider direction="vertical" v-if="j != search_exmple.length - 1"></el-divider>
                        </div>
                    </div>
                </div>
                <div v-if="search_item != ''">
                    <el-header height="40px">
                        <div class="pcga-show-record">{{ n_record }}</div>
                    </el-header>
                    <el-main>
                        <vxe-table
                            :row-key="true"
                            size="midium"
                            border="full"
                            max-height="500"
                            row-id="id"
                            :loading="loading"
                            :data="tableData"
                            :height="600"
                            style="font-family: Arial, Helvetica, sans-serif;"
                        >
                            <vxe-table-column
                                v-for="col in cols"
                                :key="col.field"
                                :field="col.field"
                                :title="col.title"
                                :width="col.width"
                                :title-help="col.msg"
                                :sortable="col.sort"
                            ></vxe-table-column>
                            <vxe-table-column
                                field="id"
                                title="Browse"
                                width="8%"
                                v-if="tableData.length != 0"
                               :title-help= "{ message: 'Click to view the association data' }"
                            >
                                <template #default="{ row }">
                                    <el-button
                                        type="success"
                                        icon="el-icon-s-promotion"
                                        size="small"
                                        circle
                                        @click="goDB(row.id)"
                                    ></el-button>
                                </template>
                            </vxe-table-column>
                        </vxe-table>
                    </el-main>
                </div>
            </div>
        </div>
        <!-- <Doc :paras="paras"></Doc> -->

        <Footer></Footer>
    </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import axios from "axios/dist/axios.min";
import { api_dir,goToResultPage } from "@/bus.js";


export default {
    name: 'browse',
    components: { Navi, Footer },
    data: function () {

        return {
            search_item: '',
            n_record: 'Related records',
            radio: 0,
            search_type: ['Phenotype', 'Tissue/Cell type', 'Gene'],
            search_exmple: [
                { 'label': 'Asthma' },
                { 'label': 'T cell' },
                { 'label': 'PTPN22' }
            ],
            tip_info: ['Input a phenotype, e.g. Asthma', 'Input a tissue/cell type, e.g. T cell', 'Input a gene symbol, e.g. PTPN22'],
            tips: '',
            loading: false,
            tableData: [],
            cols: [],
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
            types:['phenotype', 'cell', 'gene'],
            item_type: 'gene',
            item: '',
            n_record: 'Related records',
            update:true
        }
    },

    activated() {
        this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
            this.update = true
        })
    },
    deactivated() {

    },
    mounted: function () {
        this.tips = this.tip_info[this.radio];
    },
    watch: {
        radio: function () {
            this.tips = this.tip_info[this.radio];
        },

    },
    methods: {
        search() {
            if (this.search_item == '') {
                return
            }
            this.loading=true;
            this.item_type=this.types[this.radio];
            var actions = ['search_phenotype', 'search_cell', 'search_gene'];
            var action = actions[this.radio];
            var para = { 'action': action, 'term': this.search_item }
            var _this = this
            if (_this.radio == 0) {
                this.cols = [
                    { field: 'id', title: 'ID', width: '15%', msg: { message: 'GWAS ID' },sort:false  },
                    { field: 'trait', title: 'Phenotype name', width: '33%', msg: { message: 'Phenotype description' },sort:true },
                    { field: 'mesh_term', title: 'MeSH term', width: '20%', msg: { message: 'MeSH term' },sort:true },
                    { field: 'sample_size', title: 'Sample size', width: '12%', msg: { message: 'Sample size of GWAS' },sort:true },
                    { field: 'population', title: 'Population', width: '12%', msg: { message: 'Population of GWAS, see details in Help-Explanation' },sort:true },
                ];
            }
            else if (_this.radio == 1) {
                this.cols = [
                    { field: 'type', title: 'Data type', width: '20%',msg: { message: 'Tissues or single cell types (human or mouse)' },sort:true },
                    { field: 'id', title: 'ID', width: '27%',msg: { message: 'Tissue/Cell-type ID' },sort:true },
                    { field: 'cell_type', title: 'Cell type', width: '15%',msg: { message: 'Tissue/Cell-type name' },sort:true  },
                    { field: 'source', title: 'Source organ', width: '15%',msg: { message: 'Organ where the tissue/single cell type sampling' },sort:true },
                    { field: 'category_source', title: 'Category', width: '15%' ,msg: { message: 'Category of source organ' },sort:true },
                ];
            }
            else if (_this.radio == 2) {
                this.cols = [
                    { field: 'Approved symbol', title: 'Approved symbol', width: '17%',msg: { message: 'Approved symbol in HGNC' },sort:false },
                    { field: 'Chromosome', title: 'Chromosome', width: '15%',msg: { message: 'Chromosome number' },sort:false},
                    { field: 'Ensembl gene ID', title: 'Ensembl gene ID', width: '25%',msg: { message: 'Ensembl gene ID' },sort:false },
                    { field: 'Approved name', title: 'Approved name', width: '35%',msg: { message: 'Approved gene name in HGNC' },sort:false },
                ];

            }
            var type_name = { 'gtex': 'Human tissues', 'sc_hs': 'Human single cell types', 'sc_mm': 'Mouse single cell types' }
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    // _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    // _this.$notify({
                    //     title: "Success",
                    //     message: "Checked successfully",
                    //     type: "success",
                    //     duration: 2000,
                    // });

                    _this.n_record = 'Found ' + res.length + ' related ' + _this.search_type[_this.radio] + 's';
                    _this.tableData = res;
                    for (var v of _this.tableData) {
                        if ('cell_type_id' in v) {
                            v['id'] = v['cell_type_id'];
                        }
                        if ('Approved symbol' in v) {
                            v['id'] = v['Approved symbol'];
                        }
                        if ('type' in v) {
                            v['type'] = type_name[v['type']];
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },
        goExample(term, idx) {
            this.radio = idx;
            this.search_item = term;
            this.search();
        },

        querySearch(queryString, cb) {
            var maxLen = 20;
            var type = this.types;
            var para = { 'action': 'kw', 'term': queryString, 'type': type[this.radio] }
             setTimeout(() => {
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    var res = JSON.parse(JSON.stringify(response.data));

                    var restaurants = [];
                    if (res.length < maxLen) { maxLen = res.length }
                    for (var i = 0; i < maxLen; i++) {
                        restaurants.push({'value':res[i]['kw']});
                    }
                    // console.log(restaurants);
                    cb(restaurants);
                })},
                200);

        },
        handleSelect(){
            this.search();
        },
        goDB(id){
            goToResultPage(this.$router,this.item_type,id);
        }

    }
}
</script>

<style scoped>
.pcga-search-page{
    border: 1px solid #eee;
    margin: 20px auto 40px auto;
    width:100%
}
.pcga-search-box {
    width:800px;
    margin: 40px auto 15px auto;
}
.pcga-search-box >>> .el-input__inner {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
} 
.pcga-search-box  >>>.el-input__icon{
    line-height: 45px;
}
.pcga-search-box >>> .el-button {
    height: 45px;
    font-size: 16px;
} 

.pcga-search-example{
    width:500px;
    margin: 10px auto 30px auto;
}
.pcga-search-example >>> .el-radio__label{
    font-size: 16px;
}

.pcga-search-example >>> .el-radio__inner{
    width: 16px;
    height: 16px;
}

.example-list{
    width:100%;margin: 25px auto 35px auto;font-size: 16px;
}
.el-autocomplete {
    width: 100%;
}


</style>


// WEBPACK FOOTER //
// src/views/search.vue